function FetchResponseRdc() {
    const fetchResponseRdc = (state, payload) => {
        return Object.assign(Object.assign({}, state), { total: payload.result.count, data: payload.result.items, isLoading: false });
    };
    return fetchResponseRdc;
}
export default FetchResponseRdc;
//# sourceMappingURL=FetchResponseRdc.js.map